import type { ReactNode } from 'react';

export const symbol_devices_wearables: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-100v-760 760Zm240-629q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9ZM260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-760q0-24 18-42t42-18h438q24.75 0 42.38 17.62Q758-884.75 758-860v270q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-270H260v760h274q14 0 22 9.32t8 20.5q0 11.18-7.31 20.68T534-40H260Zm373-24-12-61q-38-23-59.5-61.5T540-270q0-45 21.5-83.5T621-415l12-61q2.31-11.2 10.77-17.6 8.46-6.4 19.23-6.4h94q10.77 0 19.23 6.4T787-476l12 61q38 23 59.5 61.5T880-270q0 45-21.5 83.5T799-125l-12 61q-2.31 11.2-10.77 17.6Q767.77-40 757-40h-94q-10.77 0-19.23-6.4T633-64Zm155-127.86q32-31.86 32-78T788.14-348q-31.86-32-78-32T632-348.14q-32 31.86-32 78T631.86-192q31.86 32 78 32T788-191.86Z"
		/>
	</svg>
);
